import React from "react";
import Agent from "./agent.jsx";
export const getbarbershopConfig = async (barbershopName) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  return await requests.get(
    `/Configuration/GetPublicConfiguration?barbershopName=${barbershopName}`,
    null,
    null
  );
};

export const getBarbershopSchedule = async (barbershop) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  return await requests.getAtt(
    `/BarberShop/shopSchedule?barbershop=${barbershop}`,
    null
  );
};
export const getbarbershopDetails = async (barbershopName) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  return await requests.get(
    `/BarberShop/shopContactDetail?barbershopName=${barbershopName}`,
    null,
    null
  );
};
